import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { cloneDeep } from 'lodash';

/**
 * On click popover footprint
 * @param {*} event
 * @param {*} itemData
 * @param {*} setFootPrintPopover
 * @param {*} listUser
 * @param {*} setUserFootprintList
 */
export const onHoverPopoverFootprint = (
    event,
    itemData,
    setFootPrintPopover,
    knowledgeTicketList,
    setUserFootprintList
) => {
    if(Utils.isEmptyArray(itemData?.footPrint)){
        setFootPrintPopover(null);
        return;
    }
    setFootPrintPopover(event.currentTarget);

    let userDetailList = [];
    let index = knowledgeTicketList.findIndex((element, i) => {
        return element.id === itemData.id;
    });

    let footPrintDetail = Utils.convertJSONDataToObject(
        knowledgeTicketList[index]?.footPrintDetail
    );
    let footPrint = Utils.convertJSONDataToObject(knowledgeTicketList[index]?.footPrint);

    for (let userId of footPrint) {
        for (let userIdFootprintDetail of footPrintDetail) {
            if (userId === userIdFootprintDetail.id) {
                footPrint[footPrint.indexOf(userId)] = userIdFootprintDetail;
            }
        }
    }

    footPrint.forEach(user => {
        let userName = user.fullName;
        if (!Utils.isEmptyObject(user.affiliationOrganizationInfo)) {
            let suffixUserName = Utils.getCorporationNameSuffixText(user.affiliationOrganizationInfo);
            if (suffixUserName) {
                userName = `${userName} (${suffixUserName})`;
            }
        }

        userDetailList.push(
            <OverFlowTooltipWithTabsMui
                key={`${itemData.id}_${user.id}`}
                value={userName}
                isFootPrintKnowledge={true}
                avatar={user.avatar}
                className={'footPrint-knowledge'}
            />
        );
    });

    // update footprint
    setUserFootprintList(userDetailList);
};
